import { useEffect, useState } from 'react';
import { Trash2, Info, ChevronDown, Plus } from 'react-feather';
import Select, { components } from 'react-select';
import './RulesEngineEditor.scss';
import PageGridItem from '../../Shared/Page/PageGridItem';
import FlexWrapper from '../../FlexWrapper';
import Table from '../../../components/Table/Table';
import StatusToken from '../../../components/StatusTokens';
import NumberFormat from '../../../components/Functions/NumberFormat';
import RadioButton from '../../../components/RadioButton';
import { useRemote } from '../../../Utils/Utils';

const DropdownIndicator = (props) => (
	<components.DropdownIndicator {...props}>
		<ChevronDown
			size={18}
			className="dropdown-chevron"
			style={{
				transition: "transform 0.2s",
				transform: props.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
			}}
		/>
	</components.DropdownIndicator>
);

const numericOps = ['=', '!=', '>', '>=', '<', '<='];
const stringOps  = ['=', '!=', 'contains', 'in'];

const RulesEngineEditor = ({ editMode, rules, onRulesChange }) => {

	const remote = useRemote();
	const [fields, setFields] = useState([]);

	const setConfig = onRulesChange;

	useEffect(() => {
		remote.get(`crm/lists/rules/fields`).then(setFields);
	}, []);

	console.log("Rule", rules)
	const config = rules || {"all": []};

	console.log("Config" , config)

	const operators = [
		{ value: '=', label: 'Equals' },
		{ value: '!=', label: 'Not Equals' },
		{ value: '>', label: 'Greater Than' },
		{ value: '>=', label: 'Greater Than or Equal' },
		{ value: '<', label: 'Less Than' },
		{ value: '<=', label: 'Less Than or Equal' },
		{ value: 'contains', label: 'Contains' },
		{ value: 'in', label: 'In' },
	];

	const addCondition = () => {
		const groupType = Object.keys(config)[0];
		const firstField = fields[0];
		const defaultOp = getOperators(firstField && firstField.fieldType)[0].value;
		setConfig({
			[groupType]: [...config[groupType], { field: firstField ? firstField.field : '', op: defaultOp, value: 0 }]
		});
	};

	const removeCondition = (index) => {
		const groupType = Object.keys(config)[0];
		const newConditions = config[groupType].filter((_, i) => i !== index);
		setConfig({ [groupType]: newConditions });
	};

	const getOperators = (fieldType) => {
		if (!fieldType || fieldType === 'integer' || fieldType === 'number' || fieldType === 'float')
			return operators.filter(op => numericOps.includes(op.value));
		if (fieldType === 'string' || fieldType === 'text')
			return operators.filter(op => stringOps.includes(op.value));
		return operators;
	};

	const updateCondition = (index, fieldOrUpdates, value) => {
		const groupType = Object.keys(config)[0];
		const newConditions = [...config[groupType]];
		const updates = typeof fieldOrUpdates === 'object' ? fieldOrUpdates : { [fieldOrUpdates]: value };
		newConditions[index] = { ...newConditions[index], ...updates };
		setConfig({ [groupType]: newConditions });
	};

	const handleGroupTypeChange = (value) => {
		const currentType = Object.keys(config)[0];
		const newType = value.toLowerCase();
		setConfig({ [newType]: config[currentType] });
	};

	const isGroup = (item) => {
		return item && typeof item === 'object' && (item.all || item.any);
	};

	const renderCondition = (condition, index) => {
		const fieldMeta = fields.find(f => f.field === condition.field) || {};
		const availableOps = getOperators(fieldMeta.fieldType);

		return (
			<div key={index} className="rule-condition">
				<Select
					options={fields.map(f => ({ value: f.field, label: f.humanReadable || f.field }))}
					className="search-select-field"
					classNamePrefix="search-select-field"
					value={{ value: condition.field, label: fieldMeta.humanReadable || condition.field }}
					components={{ IndicatorSeparator: () => null, DropdownIndicator }}
					onChange={(option) => {
						const newFieldMeta = fields.find(f => f.field === option.value) || {};
						const validOps = getOperators(newFieldMeta.fieldType).map(o => o.value);
						const updates = { field: option.value };
						if (!validOps.includes(condition.op)) updates.op = validOps[0];
						updateCondition(index, updates);
					}}
					menuPortalTarget={document.body}
					menuPosition="fixed"
					styles={{ container: (provided) => ({ ...provided, flex: "0 0 160px" }), menuPortal: (base) => ({ ...base, zIndex: 9999 }), menuList: (base) => ({ ...base, maxHeight: 120 }) }}
				/>

				<Select
					options={availableOps}
					className="search-select-field"
					classNamePrefix="search-select-field"
					value={availableOps.find((op) => op.value === condition.op)}
					components={{ IndicatorSeparator: () => null, DropdownIndicator }}
					onChange={(option) => updateCondition(index, "op", option.value)}
					menuPortalTarget={document.body}
					menuPosition="fixed"
					styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), menuList: (base) => ({ ...base, maxHeight: 120 }) }}
				/>

				<input
					type="text"
					value={condition.value}
					onChange={(e) => {
						const val = e.target.value;
						const numVal = Number(val);
						updateCondition(index, "value", isNaN(numVal) ? val : numVal);
					}}
					className="rule-input"
					placeholder="Value"
				/>
				{fieldMeta.unit && <span className="rule-unit">{fieldMeta.unit}</span>}

				<button onClick={() => removeCondition(index)} className="rule-delete-btn">
					<Trash2 size={16} />
				</button>
			</div>
		);
	};

	const renderGroup = () => {
		const groupType = Object.keys(config)[0];
		const conditions = config[groupType];

		return (
			<>
				<PageGridItem col="1 / span 6" id="rules-wrapper">
					{editMode ? (
						<>
							<FlexWrapper gap="s" className="mb-m">
								<h4>Match Conditions:</h4>
								<RadioButton
									label="All"
									checked={groupType === "all"}
									onClick={() => handleGroupTypeChange("All")}
								/>
								<RadioButton
									label="Any"
									checked={groupType === "any"}
									onClick={() => handleGroupTypeChange("Any")}
								/>
							</FlexWrapper>
							<div className="rule-group">
								<div>
									<div className="rule-conditions-list">{conditions.map((condition, index) => renderCondition(condition, index))}</div>

									<div className="rule-actions">
								<button onClick={addCondition} className="rule-add-btn">
									<Plus size={14} />
									Add Condition
								</button>
							</div>
								</div>
							</div>
						</>
					) : (
						<div>
							<FlexWrapper gap="s" className="mb-l">
								<Info className="colour-text-primary" />
								<span className="rule-group-description">{groupType === "all" ? "All conditions must match" : "Any condition can match"}</span>
							</FlexWrapper>
							<Table
								headers={[{ text: "Field" }, { text: "Operator" }, { text: "Value" }]}
								dataMap={conditions.map((condition, index) => {
									const fieldMeta = fields.find(f => f.field === condition.field) || {};
									return (
										<tr key={index}>
											<td>{fieldMeta.humanReadable || condition.field}</td>
											<td>
												<StatusToken type="reversed">{condition.op}</StatusToken>
											</td>
											<td>
												{typeof condition.value === 'formattedNumber' ?
													<NumberFormat value={condition.value} prefix="$" places={2} /> :
													condition.value
												}
												{fieldMeta.unit && <span className="rule-unit">{fieldMeta.unit}</span>}
											</td>
										</tr>
									);
								})}
							/>
						</div>
					)}
				</PageGridItem>
			</>
		);
	};

	return (
		<>
			<PageGridItem col="1 / span 6">
				{renderGroup()}
				{/* <div className="rules-engine-editor">
					<div className="rules-editor-container">
						<div className="rules-editor-content"></div>
						<div className="rules-editor-output">
							<h3 className="output-title">JSON Output:</h3>
							<pre className="output-code">{JSON.stringify(config, null, 2)}</pre>
						</div>
					</div>
				</div> */}
			</PageGridItem>
		</>
	);
};

export default RulesEngineEditor;